// Date presentation for the Bench Candidates report: DD/MM/YYYY everywhere.
//
// Date-only values (rollOffStartedDate, clientLastDate, bench start dates, "today" in the source
// timezone) go through the shared ADR-197 rule in utils/dateOnly.js: they are
// read as calendar dates, never as the browser's local time — otherwise a viewer
// west of UTC sees the previous day. Instants (run timestamps) are local time,
// with the clock.

import dayjs from 'dayjs';
import { formatDateOnly as formatSharedDateOnly } from '../../../utils/dateOnly';

/** 'YYYY-MM-DD…' or Date (UTC-midnight) → 'DD/MM/YYYY'; empty → '—'; unparseable → as given. */
export const formatDateOnly = (value, empty = '—') => {
  if (!value) {
    return empty;
  }
  return formatSharedDateOnly(value, 'DD/MM/YYYY', '') || String(value);
};

/** ISO instant → 'DD/MM/YYYY HH:mm' in the viewer's local time; empty → '—'. */
export const formatDateTime = (value, empty = '—') => {
  if (!value) {
    return empty;
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : String(value);
};
